import React,{useState,useEffect} from 'react'
import {URL} from '../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { invokeCancelDates, invokeReservations } from '../ServiceCalls/ApiCalls';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AdminComponent.css'
import { lightFormat } from 'date-fns';


function ManagePermBookingComponent() {

  const navigate = useNavigate()
  const user_info = JSON.parse(localStorage.getItem('user'))
  const[permreservations,setPermReservations] = useState([])
  const[searchDate,setSearchDate] = useState(new Date().toLocaleDateString("fr-CA"))
  const[startDate,setStartDate] = useState('')
  const[endDate,setEndDate] = useState('')
  const[minDate,setMinDate] = useState('')
  const[maxDate,setMaxDate] = useState('')
  const[bookingId,setBookingId]=useState('')
  const[rowId,setRowId]=useState(0)
  const[searchText,setSearchText] = useState('')
  const[startTime,setStartTime] = useState('')
  const[endTime,setEndTime] = useState('')
  const[showEditComponent,setShowEditComponent] = useState(false)
  const[displayValidation,setDisplayValidation] = useState(false)
  const[dateSelected,setDateSelected] = useState(new Date().toLocaleDateString("fr-CA"))
  const[currentDate,setCurrentDate] = useState(new Date().toLocaleDateString("fr-CA"))
  const[bookingRowEdited,setBookingRowEdited] = useState({})
  const[courtBooked,setCourtBooked] = useState('')
  const[price,setPrice] = useState(0.00)
  const[cancelDates,setCancelDates] = useState([])
  const[isLoading,setIsLoading] = useState(true)
  const[isRefreshing,setIsRefreshing] = useState(false)
  const [formData, setFormData] = useState({
    discount: 0,
    netPrice:0,
    contact: '',
    email: '',
    userName: '',
    booking_date_end: ''
});

  useEffect(() =>{
    if(!localStorage.getItem('user')){
        navigate('/')
    }
    async function invokePBookings(){
        setIsLoading(true);
        try {
            const user_perm_reservations = await invokeReservations();
            const new_cust_perm_booking_response = user_perm_reservations.map(item =>{
                return {...item,isEditing:false}
            })
            setPermReservations(new_cust_perm_booking_response)
            const cancel_dates_data = await invokeCancelDates();
            setCancelDates([...cancel_dates_data])
        } catch (error) {
            console.error('Error fetching permanent bookings:', error);
            toast.error('Failed to load permanent bookings', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setIsLoading(false);
        }
    }

    invokePBookings()
  },[])
  const refreshBookings = async () => {
    setIsRefreshing(true);
    try {
      const user_perm_reservations = await invokeReservations();
      const new_cust_perm_booking_response = user_perm_reservations.map(item =>{
          return {...item,isEditing:false}
      })
      setPermReservations(new_cust_perm_booking_response)
      const cancel_dates_data = await invokeCancelDates();
      setCancelDates([...cancel_dates_data])
      
      toast.success('Permanent bookings refreshed successfully!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error('Error refreshing permanent bookings:', error);
      toast.error('Failed to refresh permanent bookings', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsRefreshing(false);
    }
  };

  const options = (method = "GET",body) =>{
    return {
        method,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    }
  }

  const toggleRow = (row,rid) => {

     const{booking_date_start,booking_date_end,_id} = row;
     setShowEditComponent(false)
     setBookingRowEdited({...row})
     setBookingId(_id)
     setRowId(rid)
     setStartDate('')
     setEndDate('')
     setDisplayValidation(false)
     setMinDate(booking_date_start)
     setMaxDate(booking_date_end)

    //  console.log('booking start date',row.booking_date_start)

    // console.log('booking end date',row.booking_date_end)

  }
  const deletePBookings = async(bookingid,rowid) => {

    window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`)
    try{
        const delete_pbooking_response = await fetch(`${URL}` + '/perbookings/'+`${bookingid}`, options("DELETE"));
        if(delete_pbooking_response.ok){
            const new_perm_bookings = permreservations.filter(pb => pb._id !== bookingid)
            const dataDelete = [...new_perm_bookings];
            setPermReservations([...dataDelete])
            toast.success('🦄 Wow Row Deleted!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }catch(err){
        console.log(err)
    }
  }
  const handleUpdate = async() => {

    console.log('update Data',formData)
    // const newFormData = {...formData,...bookingRowEdited}
    try{

        const edit_booking_response = await fetch(`${URL}` + '/perbookings/'+`${bookingId}`, options("PATCH",bookingRowEdited));

        if(edit_booking_response.ok){

            const edit_booking_status = await edit_booking_response.json();
            const dataUpdate = [...permreservations]

            const newDataUpdate = dataUpdate.map(data => {
                if(data._id === bookingId)
                    return {...edit_booking_status};
                else
                    return data;
            })
            // dataUpdate[rowId] = {...edit_booking_status};
            // console.log('data-update',dataUpdate[rowId])

            setPermReservations([...newDataUpdate])

            // console.log('update response :',edit_booking_response)
            // toggleRow(bookingid,rowid)

            toast.success('🦄 Wow Row Updated!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }
        else{
           // alert('Update Failed')
           toast.error('🦄 OOps Update Failed!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }
    }
    catch(err){
        console.log(err)
    }

  }
  const handleDateChange = e => {

    setDisplayValidation(false)
    const{name,value} = e.target;
    if(name === 'end-date')
        setEndDate(value)
    else if(name === 'start-date')
        setStartDate(value)
  }
  const addCancelDates = async() =>{

     if(minDate.length > 0 && maxDate.length > 0){

        if(new Date(startDate) >= new Date(minDate)  && new Date(endDate) <= new Date(maxDate) && new Date(startDate) < new Date(endDate)){
           const cancel_dates_response = await fetch(`${URL}` + '/canceldates',options("POST",{
            "booking_id":bookingId,
            "start_date":startDate,
            "end_date":endDate
           }))
           if(cancel_dates_response.ok){
            const cancel_dates_resp = await cancel_dates_response.json();
            const{dates} = cancel_dates_resp;
            setCancelDates(prev =>[ ...prev,dates])
            toast.success('🦄 Wow Dates Added!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
           }
        }
        else{
            //setDisplayValidation(true)
            toast.error('🦄 OOps Dates Mismatch!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }

     }

  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookingRowEdited((prevData) => ({ ...prevData, [name]: value }));
};
  const handleReset = () =>{
    setBookingId('')
    setStartDate('')
    setEndDate('')
    // handleToggle()
  }
  const handleToggle = () => {
    setShowEditComponent(!showEditComponent)
  }
  const deleteCancelDates = async(b_id,rowid) => {
    window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`)
    try{
        const delete_cancel_dates_response = await fetch(`${URL}` + '/canceldates/'+`${b_id}`, options("DELETE"));
        if(delete_cancel_dates_response.ok){
            const cancel_dates_by_bookings = cancelDates.filter(d => d._id === b_id)
            const dataDelete = [...cancel_dates_by_bookings];
            dataDelete.splice(rowid,1)
            setCancelDates(dataDelete)
            toast.success('🦄 Wow Date Deleted!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else{
            toast.error('🦄 OOps Dates Delete!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }
    }catch(err){
        console.log(err)
    }
  }
  const applyDiscount = (totalPrice,discountValue) =>{
    // e.preventDefault()
    let discountAmount = Math.abs(discountValue / 100 );
    let d_price = totalPrice * discountAmount ;
    let priceAfterDiscount = totalPrice - d_price;
    bookingRowEdited.netPrice = priceAfterDiscount;
    return priceAfterDiscount;
}

  return (
      <div className="admin-panel">
          <div className='container admin-container'>
              <div className="row mt-5">
                <div className="col-md-12 col-sm-12">
                  <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="mb-1">
                        <i className="fa fa-calendar-check-o text-warning me-2"></i>
                        Manage Permanent Bookings ({permreservations.length})
                      </h3>
                      <p className="text-muted">Manage all permanent reservation records and cancel dates</p>
                    </div>
                    <div className="failed-bookings-actions">
                      <button 
                        className="btn btn-outline-secondary me-2"
                        onClick={refreshBookings}
                        disabled={isRefreshing}
                      >
                        {isRefreshing ? (
                          <>
                            <i className="fa fa-spinner fa-spin me-1"></i>
                            Refreshing...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-refresh me-1"></i>
                            Refresh
                          </>
                        )}
                      </button>
                      <button 
                        className="btn btn-primary"
                        onClick={() => navigate('/user')}
                      >
                        <i className="fa fa-arrow-left me-1"></i>
                        Back to Dashboard
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter Section */}
              <div className="mb-4">
                  <div className="table-responsive">
                      <div className="d-flex align-items-center gap-3 mb-3" style={{padding: '1rem', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '0.375rem'}}>
                          <input
                              type="search"
                              className='form-control'
                              name="search"
                              placeholder='Search User...'
                              value={searchText}
                              onChange={e => setSearchText(e.target.value)}
                              id="search"
                              style={{flex: '1'}}
                          />
                          <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setSearchText('')}
                              disabled={!searchText}
                              style={{minWidth: '120px'}}
                          >
                              Clear Filter
                          </button>
                      </div>
                      
                      {/* Filter Summary */}
                      {searchText && (
                          <div className="mb-3" style={{padding: '0.5rem 1rem', backgroundColor: '#e9ecef', borderRadius: '0.375rem'}}>
                              <small className="text-muted">
                                  Active Filters: 
                                  <span className="badge bg-primary ms-1 me-1">
                                      User: "{searchText}"
                                  </span>
                                  | Showing filtered results
                              </small>
                          </div>
                      )}
                  </div>
              </div>
              
              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                  <div className="text-center">
                    <div className="spinner-border text-warning" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Loading permanent bookings...</p>
                  </div>
                </div>
              ) : (
                <div className="perm-booking-table table-responsive">
                  <table className='table table-bordered table-hover my-5 perm-admin-tab'>
                      <thead className="table-warning text-center">
                          <tr>
                            <th>S.No</th>
                            <th>User Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Court</th>
                            <th>Day</th>
                            <th>Contact</th>
                            <th>Grand Total-A$</th>
                            <th>Discount %</th>
                            <th>Net Total</th>
                            <th>Payment Mode</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            permreservations.length > 0 ? permreservations.filter(item =>{
                                return searchText.toLowerCase() === '' ? item : item.userName.toLowerCase().includes(searchText.toLocaleLowerCase())
                            //    const textMatch = searchText.toLowerCase() === '' ? item : item.userName.toLowerCase().includes(searchText.toLowerCase());
                            //    const dateMatch = searchDate === null || (item.booking_date_start === null && item.booking_date_end === null) ? true :
                            //     (new Date(searchDate).toLocaleDateString() === new Date(item.booking_date_start).toLocaleDateString() ||
                            //     new Date(searchDate).toLocaleDateString() === new Date(item.booking_date_end).toLocaleDateString() ||
                            //     (new Date(searchDate) >= new Date(item.booking_date_start) && new Date(searchDate) <= new Date(item.booking_date_end)));
                            //    return textMatch && dateMatch;
                              })
                              .sort((a, b) => a.booking_date_start < b.booking_date_start ? 1 : -1)
                              .map((r, i) => (<tr key={i}>
                                  <td>{i + 1}</td>
                                  <td title={r.userName}>{r.userName}</td>

                                  <td>{r.booking_date_start}</td>

                                  <td>{r.booking_date_end}</td>

                                  <td>{r.booking_time_start}</td>

                                  <td>{r.booking_time_end}</td>

                                  <td>{r.booking_item}</td>

                                  <td>{r.day_of_week}</td>
                                  <td title={`Contact: ${r.contact}, Email: ${r.email}`}>
                                    <div className="contact-info">
                                      <div className="contact-phone">{r.contact}</div>
                                      <div className="contact-email">{r.email}</div>
                                    </div>
                                  </td>
                                  <td className="text-end" title={`Grand Total: A$${r.grandTotal}`}>
                                    A${r.grandTotal}
                                  </td>
                                  <td className="text-center" title={`Discount: ${r.discount}%`}>
                                    {r.discount}%
                                  </td>
                                  <td className="text-end" title={`Net Total: A$${r.netPrice}`}>
                                    A${r.netPrice}
                                  </td>
                                  <td>
                                  <span className={r.pay_status === 'UnPaid' ? 'bg-danger text-white' : r.pay_status === 'Complimentary' ? 'bg-info text-white' : 'bg-success text-white'}>{r.pay_status}</span>
                                  </td>
                                  <td>
                                      <div className="action-buttons">
                                        <i
                                            onClick={() => toggleRow(r, i)}
                                            className='fa fa-pencil'
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModalPop"
                                            title="Edit Booking"
                                        ></i>
                                        <i
                                            onClick={() => deletePBookings(r._id, i)}
                                            className='fa fa-trash'
                                            title="Delete Booking"></i>
                                      </div>
                                  </td>
                                </tr>)
                            )
                            :
                            <tr>
                                <td colSpan={14} className='text-center'>
                                    <p>No Permanant Booking Records Available...</p>
                                </td>
                            </tr>
                        }
                    </tbody>
                  </table>
                </div>
              )}
          </div>

           <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false"  id="editModalPop">
                        <div className="modal-dialog modal-dialog-centered modal-sm modal-lg modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                        <h5 className="modal-title" id="staticBackdropLabel">Add Your Holidays</h5>
                                        <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                onClick={() => handleReset()}
                                                aria-label="Close"></button>

                                </div>
                                <div className="modal-header">
                                        <div class="form-check form-switch">
                                            <input
                                            class="form-check-input"
                                            type="checkbox"
                                            id="flexSwitchCheckChecked"
                                            checked={showEditComponent}
                                            onChange={handleToggle} />
                                            <label class="form-check-label fs-6" for="flexSwitchCheckChecked">Edit Booking</label>
                                        </div>
                                    </div>
                                <div className="border rounded p-2 editBooking">
                                    {
                                        showEditComponent ?
                                            <div className="container-fluid px-3 py-2">
                                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
                                                    {/* Date Inputs */}
                                                    <div className="col">
                                                        <div className="mb-3">
                                                            <label htmlFor="startDate" className="form-label small">StartDate</label>
                                                            <input
                                                                type="date"
                                                                name="startDate"
                                                                className="form-control"
                                                                value={formData.startDate || bookingRowEdited.booking_date_start}
                                                                onChange={e => handleChange(e)}
                                                                id="startDate"
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="endDate" className="form-label small">EndDate</label>
                                                            <input
                                                                type="date"
                                                                name="booking_date_end"
                                                                className="form-control"
                                                                value={formData.endDate || bookingRowEdited.booking_date_end}
                                                                onChange={e => handleChange(e)}
                                                                id="booking_date_end"
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* Price Inputs */}
                                                    <div className="col">
                                                        <div className="mb-3">
                                                            <label htmlFor="total" className="form-label small">Total</label>
                                                            <input
                                                                type="number"
                                                                name="grandTotal"
                                                                className="form-control"
                                                                value={formData.grandTotal || bookingRowEdited.grandTotal}
                                                                onChange={e => handleChange(e)}
                                                                id="total"
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="mb-3">
                                                            <label htmlFor="discount" className="form-label small">Discount</label>
                                                            <input
                                                                type="number"
                                                                name="discount"
                                                                className="form-control"
                                                                value={formData.discount || bookingRowEdited.discount}
                                                                onChange={e => handleChange(e)}
                                                                id="discount"
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* Net Price */}
                                                    <div className="col">
                                                        <div className="mb-3">
                                                            <label htmlFor="netPrice" className="form-label small">NetPrice</label>
                                                            <input
                                                                type="number"
                                                                name="netPrice"
                                                                className="form-control"
                                                                value={formData.netPrice || applyDiscount(bookingRowEdited.grandTotal,bookingRowEdited.discount)}
                                                                onChange={e => handleChange(e)}
                                                                id="netPrice"
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* User Details */}
                                                    <div className="col">
                                                        <div className="mb-3">
                                                            <label htmlFor="userName" className="form-label small">UserName</label>
                                                            <input
                                                                type="text"
                                                                name="userName"
                                                                className="form-control"
                                                                value={formData.userName || bookingRowEdited.userName}
                                                                onChange={e => handleChange(e)}
                                                                id="userName"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="mb-3">
                                                            <label htmlFor="email" className="form-label small">Email</label>
                                                            <input
                                                                type="text"
                                                                name="email"
                                                                className="form-control"
                                                                value={formData.email || bookingRowEdited.email}
                                                                onChange={e => handleChange(e)}
                                                                id="email"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="mb-3">
                                                            <label htmlFor="contact" className="form-label small">Contact</label>
                                                            <input
                                                                type="text"
                                                                name="contact"
                                                                className="form-control"
                                                                value={formData.contact || bookingRowEdited.contact}
                                                                onChange={e => handleChange(e)}
                                                                id="contact"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Update Button */}
                                                <div className="row mt-3">
                                                    <div className="col-12 text-center">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={handleUpdate}
                                                        >
                                                            Update
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        :
                                        <div className="container border">
                                            <div className="row d-flex justify-content-around">
                                                <div>
                                                    <label htmlFor="start-date" className="small">Start-Date</label>
                                                    <input
                                                        type="date"
                                                        name="start-date"
                                                        className="form-control"
                                                        min = {minDate}
                                                        max = {maxDate}
                                                        value={startDate}
                                                        onChange={e => handleDateChange(e)}
                                                        id="start-date" />
                                                </div>
                                                <div>
                                                    <label htmlFor="end-date" className="small">End-Date</label>
                                                    <input
                                                        type="date"
                                                        name="end-date"
                                                        className="form-control"
                                                        min = {minDate}
                                                        max = {maxDate}
                                                        value={endDate}
                                                        onChange={e => handleDateChange(e)}
                                                        id="end-date" />
                                                </div>
                                                <div className="col-md-2 my-1">
                                                    <i
                                                        onClick={() => addCancelDates()}
                                                        className="fa fa-plus-circle"></i>
                                                </div>
                                            </div>
                                            {

                                            }
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    {
                                                        displayValidation ? <span className='text-danger text-center small my-2'>Oops!! dates out of range..</span> : ''
                                                    }
                                                </div>
                                            </div>
                                            <div className="row my-3">
                                                <div className="col-md-12 container">
                                                    <table className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th className='small text-center'>Start Date</th>
                                                                <th className='small text-center'>End Date</th>
                                                                <th className='text-center'>
                                                                    <i className="fa fa-cog"></i>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {

                                                                cancelDates.filter(d => d.booking_id === bookingId).map((cd, i) => <tr key={i}>
                                                                    <td>{cd.start_date}</td>
                                                                    <td>{cd.end_date}</td>
                                                                    <td>
                                                                        <i
                                                                            onClick={() => deleteCancelDates(cd._id, i)}
                                                                            className="fa fa-trash"></i>
                                                                    </td>
                                                                </tr>
                                                                )
                                                            }
                                                        </tbody>

                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => handleReset()}
                                        data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>

                </div>
                
                {/* Back to Top Button */}
                <button
                  className="btn btn-primary back-to-top-btn"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  title="Back to Top"
                >
                  <i className="fa fa-arrow-up"></i>
                </button>
                
                <ToastContainer/>
            </div>
  )
}

export default ManagePermBookingComponent